import ApiService from '../api.service';

const StudentOccurrences = {
  index: params => ApiService.query('/api/v2/principals/me/student_occurrences', params),
  alerts: params => ApiService.query('/api/v2/principals/me/student_occurrences/alerts_graph_indiscipline_and_health', params),
  alertsGraphSocioemptional: params => ApiService.query('/api/v2/principals/me/student_occurrences/alerts_graph_socioemotional', params),
  socioemotionalAverageByCategory: params => ApiService.query('/api/v2/principals/me/student_occurrences/socioemotional_average_by_category', params),
};

export default StudentOccurrences;
